/* eslint-disable */
import store from "../../store/index";
import axios from "axios";

export default {
  name: "ScheduleCyclePopUp",
  props: {
    patientid: String,
    cycleid: Number
  },
  data() {
    return {
      baseurl: process.env.VUE_APP_Service_URL,
      patientId: this.patientid,
      cycleId: this.cycleid,

      cycleData: {},

      cycleForm: {
        startDate: "",
        endDate: ""
      },

      cycleErrors: {
        startDate: false
      },

      isCreating: false,

      today: new Date().toISOString().split("T")[0]
    };
  },

  async mounted() {
    await this.getCycleData();
  },

  methods: {
    calculateEndDateFromDuration(startDate, durationDays) {
      if (!startDate) return "";

      const parsedDuration = parseInt(durationDays, 10);
      const safeDuration = Number.isFinite(parsedDuration) && parsedDuration >= 0 ? parsedDuration : 0;

      const start = new Date(`${startDate}T00:00:00`);
      if (Number.isNaN(start.getTime())) return "";

      start.setDate(start.getDate() + safeDuration);
      return start.toISOString().split("T")[0];
    },
    onStartDateChange() {
      this.cycleErrors.startDate = !this.cycleForm.startDate;
      if (this.cycleErrors.startDate) return;

      this.cycleForm.endDate = this.calculateEndDateFromDuration(
        this.cycleForm.startDate,
        this.cycleData?.cycleDuration
      );
    },
    async getCycleData() {
      try {
        const currentstudy = store.getters.getStudyIs;
        const response = await axios.get(
          `${this.baseurl}/management/cycle/getcyclebycycleid?cycleId=${this.cycleId}&studyId=${currentstudy}`,
          {
            headers: {
              Authorization: "Bearer " + store.getters.getIdToken,
              "Content-Type": "application/json"
            }
          }
        );
        this.cycleData = response.data;
      } catch (err) {
        console.error("Error fetching cycle data:", err);
      }
    },
    async closeModal() {
      this.$emit("closeModal");
      
    },
    async createSchedule() {
      if (this.isCreating) return;

      // Basic required validation
      this.cycleErrors.startDate = !this.cycleForm.startDate;
      if (this.cycleErrors.startDate) return;

      // Helper: convert "YYYY-MM-DD" → Date at UTC midnight → ISO
      function toUTCDateOnlyISO(dateStr) {
        if (!dateStr) return null;
        // Parse as local date first (browser does this for YYYY-MM-DD)
        const d = new Date(dateStr);
        // Rebuild as UTC midnight to avoid timezone shifts
        const utcMidnight = new Date(Date.UTC(d.getFullYear(), d.getMonth(), d.getDate()));
        return utcMidnight.toISOString(); // e.g., "2026-02-27T00:00:00.000Z"
      }

      const payload = {
        subjectId: this.patientId,
        cycleId: this.cycleData.cycleId,
        studyId: store.getters.getStudyIs,
        cycleStartDate: toUTCDateOnlyISO(this.cycleForm.startDate),
        cycleEndDate:   toUTCDateOnlyISO(this.cycleForm.endDate) // allow null if not provided
      };

      console.log("payload being sent", payload);

      try {
        this.isCreating = true;
        const response = await axios.post(
          `${this.baseurl}/management/patientschedule/schedulecycle`,
          payload,
          {
            headers: {
              Authorization: "Bearer " + store.getters.getIdToken,
              "Content-Type": "application/json"
            }
          }
        );

        alert("Cycle scheduled successfully");
        this.$emit("cycleScheduled", {
          patientId: this.patientId,
          cycleId: this.cycleId
        });
        this.$emit("closeModal");
      } catch (err) {
          const message =
          err?.response?.data?.detail ||
          'Something went wrong';

          alert(message);
        } finally {
          this.isCreating = false;
        }
    }
  }
};

